import { render } from "./EmailConfirmation.vue?vue&type=template&id=6c6ff92c"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Authentication/EmailConfirmation/EmailConfirmation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6ff92c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6ff92c', __exports__)) {
    api.reload('6c6ff92c', __exports__)
  }
  
  module.hot.accept("./EmailConfirmation.vue?vue&type=template&id=6c6ff92c", () => {
    api.rerender('6c6ff92c', render)
  })

}


export default __exports__